import { formatCurrency, getOfferNumericFieldValue } from 'embed/utils'
import { TermUnit } from '@evenfinancial/even-ts-static'
import { LoanOffer } from 'embed/constants/models'

export const APR_FIXED = 'Fixed'
export const APR_LABEL = 'APR'
export const APR_POSTFIX = '%'
export const APR_VARIABLE = 'Variable'
export const AUTOPAY = '* w/AutoPay and excellent credit'
export const DAGGER = '†'
export const EMPTY = ''
export const LEGAL = '*'
export const LOAN_AMOUNT_PREFIX = '$'
export const REWARDS_AMOUNT_PREFIX = '$'
export const MONTHLY_PAYMENT_LABEL = 'Est. Monthly Payment'
export const PREVIEW_APR_LABEL = 'APRs From'
export const PREVIEW_MONTHLY_PAYMENT_LABEL = 'Max Loan Amount'
export const PREVIEW_TERM_LABEL = 'Max Term'
export const TERM_LABEL = 'Term of Loan'
export const OPEN_TERM_LABEL = 'No Term Limit'
export const OPEN_TERM_LENGTH = 'Open'

enum PreviewTermUnits {
  Days = 'DAYS',
  Months = 'MO',
  Years = 'YR',
}

export const getAprDisplay = (apr) => Math.round(apr * 100) / 100
export const getPreviewAprDisplay = (offer: LoanOffer) =>
  offer.minApr !== offer.maxApr && offer.maxApr
    ? `${getAprDisplay(offer.minApr)} - ${getAprDisplay(offer.maxApr)}`
    : getAprDisplay(offer.minApr)
export const getPreviewTermUnits = (offer: LoanOffer) => {
  switch (offer.termUnit) {
    case TermUnit.Days:
      return PreviewTermUnits.Days
    case TermUnit.Months:
      return PreviewTermUnits.Months
    default:
      return PreviewTermUnits.Years
  }
}
// Get the Payment amount from meanMonthlyPayment, fallback to monthlyPayment if empty
export function getMonthlyPaymentDisplay(offer: LoanOffer, prefix = LOAN_AMOUNT_PREFIX): string {
  let paymentAmount
  if (offer.meanMonthlyPayment) {
    paymentAmount = getOfferNumericFieldValue(offer.meanMonthlyPayment, {
      prefix,
      transformValue: formatCurrency,
    })
  } else {
    if (offer.monthlyPayment) {
      paymentAmount = getOfferNumericFieldValue(offer.monthlyPayment, {
        prefix,
        transformValue: formatCurrency,
      })
    }
  }
  return paymentAmount
}

export function getMaxAmountDisplay(offer: LoanOffer, prefix?: string): string | undefined {
  return getOfferNumericFieldValue(offer.maxAmount, {
    prefix,
    transformValue: formatCurrency,
  })
}
